import { useEffect, useState } from "react";
import PickupAddressDrawer from "../components/ui/PickupAddressDrawer";
import RateOrderAssignDrawer from "../components/ui/RateOrderAssignDrawer";
import RateReturnAssignDrawer from "../components/ui/RateReturnAssignDrawer";

const DrawerProvider = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }
  return (
    <>
      <PickupAddressDrawer />
      <RateOrderAssignDrawer />
      <RateReturnAssignDrawer />
    </>
  );
};

export default DrawerProvider;
